import { Task } from 'modules/Tasks/types';
import interpolate from 'modules/Tasks/utils/interpolate';

/**
 * Derives the display strings rendered by Task primitives (TaskRow, TaskCard, etc.). Centralized
 * so the source-of-truth rules (e.g., action_description fallback) live in one place.
 */
export default function getTaskDisplay(task: Task): { title: string; description: string; ctaLabel: string } {
    return {
        title: interpolate(task.task_template.display_name, task.context),
        description: task.context.action_description || interpolate(task.task_template.instructions, task.context),
        ctaLabel: task.task_template.submit_action.label,
    };
}
